<template>
  <div class="page">
    <div class="page-title">Facility Owner Companies</div>
    <double-pane :paneState="paneState">
      <template v-slot:left-pane>
        <div class="left">
          <h4 class="text-center">Companies</h4>
          <loading-panel :loading="loading" class="m-auto">
            <div class="my-3 input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="filter">
                  <i class="fa fa-search"></i>
                </span>
              </div>
              <input
                v-model.trim="filter"
                @keyup="applyFilter()"
                class="form-control"
                aria-describedby="filter"
                placeholder="filter by name"
              />
            </div>
            <div
              v-for="(company, ind) in filteredCompanies"
              :key="`${ind}_loc`"
            >
              <button
                class="waves-effect company-button btn w-100"
                :class="
                  company === selected ? 'btn-primary' : 'btn-outline-primary'
                "
                @click="onSelected(company)"
              >
                {{ company.name }}
              </button>
            </div>
          </loading-panel>
          <error-panel class="m-auto" :errors="errors"></error-panel>
        </div>
      </template>
      <template v-slot:right-pane>
        <div class="right">
          <company :company="selected"></company>
        </div>
      </template>
      <template v-slot:back-button>
        <button class="btn back-btn" @click.prevent="paneState = 0">
          <i class="material-icons">navigate_before</i>
          <div>Back</div>
        </button>
      </template>
    </double-pane>
  </div>
</template>

<script>
import Company from "@/components/Company";
import DoublePane from "@/layouts/DoublePane";

export default {
  name: "facility-owner-companies",
  components: {
    DoublePane,
    Company,
  },
  data: () => ({
    loading: true,
    errors: [],
    filteredCompanies: [],
    companies: [],
    selected: null,
    filter: "",
    paneState: 0,
  }),
  methods: {
    onSelected(company) {
      this.selected = company;
      this.paneState = 1;
    },
    applyFilter() {
      this.filteredCompanies = this.companies.filter((company) =>
        !company.isVendor &&
        company.name.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getCompanies();
      if (response.data.companies && response.data.companies.length > 0) {
        this.companies = response.data.companies;
        this.applyFilter();
      } else {
        this.errors = ["No companies found."];
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.logo {
  max-width: 100%;
  max-height: 100%;
}

.company-button {
  margin-top: 0.5rem;
}

.left,
.right {
  padding: 20px;
}
</style>
